import { Fragment, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import SidebarLink from 'src/components/atoms/SidebarLink'
// import { SidebarItems } from "src/data/SidebarLinks.js";
import Logo from 'src/logos/Logo'
// import SidebarLinks from "src/data/SidebarLinks";
import LocationSelector from '../molecules/LocationSelector'
import css from './Sidebar.module.scss'
import { AnimatePresence, motion } from 'framer-motion'
// import { getLoc } from 'src/actions/getlocations'
import { useSidebar } from 'src/utils/SidebarProvider'
import { useIsMobile, useIsTablet } from 'src/utils/UseMediaQuery'
import { getCounts, getPaymentLink } from 'src/slices/info'

export default function Sidebar() {
	const dispatch = useDispatch()
	const { counts, paymentLink, bankingCompleted, status } = useSelector(state => state.info)
	const { permissions, type } = useSelector(state => state.auth)

	useEffect(() => {
		dispatch(getCounts())
		dispatch(getPaymentLink())
	}, [])
	// useEffect(() => {
	// 	if (!status.setPaymentLink.isLoading) dispatch(getPaymentLink())
	// }, [status.setPaymentLink])

	const Dashboard = [
		{ title: 'Home', iconName: 'home', link: '/home' }, // or "reports"?
		...(permissions.read.includes('analytics')
			? [
					{
						title: 'Analytics',
						iconName: 'chart-bar',
						link: '/analytics',
					},
			  ]
			: []), // or "reports"?
		// {title: "Campaigns", iconName: "hashtag", link: "/campaigns"}
		...(permissions.read.includes('orders')
			? [
					{
						title: 'Orders',
						iconName: 'receipt',
						link: '/orders',
						notification: counts.orders,
						showNotification: true,
					},
			  ]
			: []),
	]
	const Inventory = [
		...(permissions.read.includes('offers')
			? [
					{
						title: 'Offers',
						iconName: 'tags',
						link: '/offers',
						notification: counts.offers,
						showNotification: true,
						...((permissions.read.includes('pendingOffers') ||
							permissions.create.includes('offers')) && {
							sublinks: [
								...(permissions.read.includes('pendingOffers')
									? [
											{
												title: 'Pending',
												iconName: 'clock',
												link: '/pending-offers',
												notification: counts.pendingOffers, //change
												showNotification: true,
											},
									  ]
									: []),
								...(permissions.create.includes('offers')
									? [
											{
												title: 'Create Offer',
												iconName: 'plus',
												link: '/offers/new',
											},
									  ]
									: []),
							],
						}),
					},
			  ]
			: []),
		...(!permissions.read.includes('offers') && permissions.read.includes('pendingOffers')
			? [
					{
						title: 'Pending Offers',
						iconName: 'clock',
						link: '/pending-offers',
						notification: counts.pendingOffers,
						showNotification: true,
						...(permissions.create.includes('offers') && {
							sublinks: [
								{ title: 'Create Offer', iconName: 'plus', link: '/offers/new' },
							],
						}),
					},
			  ]
			: []),

		...(permissions.read.includes('items')
			? [
					{
						title: 'Items',
						iconName: 'tag',
						link: '/items',
						notification: counts.items,
						showNotification: true,
						...((permissions.read.includes('pendingItems') ||
							permissions.create.includes('items')) && {
							sublinks: [
								...(permissions.read.includes('pendingItems')
									? [
											{
												title: 'Pending',
												iconName: 'clock',
												link: '/pending-items',
												notification: counts.pendingItems,
												showNotification: true,
											},
									  ]
									: []),
								...(permissions.create.includes('items')
									? [
											{
												title: 'Create Item',
												iconName: 'plus',
												link: '/items/new',
											},
									  ]
									: []),
							],
						}),
					},
			  ]
			: []),

		...(!permissions.read.includes('items') && permissions.read.includes('pendingItems')
			? [
					{
						title: 'Pending Items',
						iconName: 'clock',
						link: '/pending-items',
						notification: counts.pendingItems,
						showNotification: true,
						...(permissions.create.includes('items') && {
							sublinks: [
								{ title: 'Create Item', iconName: 'plus', link: '/items/new' },
							],
						}),
					},
			  ]
			: []),

		// ...(permissions.read.includes('categories')
		// 	? [{ title: 'Categories', iconName: 'swatchbook', link: '/categories' }]
		// 	: []),
	]

	const Store = [
		...(permissions.read.includes('store_info')
			? [
					{
						link: '/store-details',
						title: 'Store Details',
						iconName: 'store-alt',
					},
			  ]
			: []),

		...(permissions.read.includes('banking')
			? [
					{
						link: paymentLink,
						title: 'Bank',
						iconName: 'credit-card',

						link: '/bank',

						...(bankingCompleted && {
							iconRight: 'check-circle',
							iconRightColor: 'green-400',
						}),
						...(!bankingCompleted && {
							iconRight: 'exclamation-circle',
							iconRightColor: 'red-400',
						}),
					},
			  ]
			: []),
		// ...(permissions.read.includes('pos')
		// 	? [
		// 			{
		// 				link: '/pos',
		// 				title: 'POS',
		// 				iconName: 'cash-register',
		// 			},
		// 	  ]
		// 	: []),
		...(type == 'merchant'
			? [
					{
						link: '/employees',
						title: 'employees',
						iconName: 'user-friends',
					},
			  ]
			: []),
		...(permissions.read.includes('charities')
			? [
					{
						link: '/charities',
						title: 'charities',
						iconName: 'hand-holding-heart',
					},
			  ]
			: []),
	]

	const links = [
		...(Dashboard.length > 0 ? [{ title: 'Dashboard', links: Dashboard }] : []),
		...(Inventory.length > 0 ? [{ title: 'Inventory', links: Inventory }] : []),
		...(Store.length > 0 ? [{ title: 'Store', links: Store }] : []),
	]

	const { open, toggleSidebar } = useSidebar()

	const sidebarVariants = {
		sidebarOpen: {
			transform: 'translateX(0px)',
		},

		sidebarClosed: {
			transform: 'translateX(-296px)',
		},
	}

	const isMobile = useIsMobile()
	const isTablet = useIsTablet()

	const overlayStyle = isMobile || isTablet

	return (
		<>
			<motion.div
				variants={sidebarVariants}
				animate={open ? 'sidebarOpen' : 'sidebarClosed'}
				transition={{ ease: 'easeInOut', duration: 0.5 }}
				className={css['sidebar']}>
				<motion.div className={css['intro']}>
					<Logo
						color='white'
						height='48px'
					/>
				</motion.div>

				<LocationSelector />

				<motion.div className={css['navigation']}>
					{links?.map(section => {
						return (
							<nav
								className={css['section']}
								key={section.title}>
								<h4 className={css['section__title']}>{section.title}</h4>
								{section.links.map(item => {
									return (
										<Fragment key={item.title + '34'}>
											<SidebarLink
												{...item}
												key={item.title}
											/>
											{item.sublinks?.map((sublink, index) => {
												// isFirst is used for css left side borders. Since the items are not children of a div, I couldn't use nth-child or nth-of-type so I added a custom prop to check if the link is first in list or not
												return (
													<SidebarLink
														{...sublink}
														key={sublink.title}
														isSubLink={true}
														isFirst={index === 0}
														status={status.getCounts}
													/>
												)
											})}
										</Fragment>
									)
								})}
							</nav>
						)
					})}

					<nav className={css['section']}>
						<SidebarLink
							title='Settings'
							iconName='cog'
							link='/settings'
						/>
					</nav>
				</motion.div>
			</motion.div>

			<AnimatePresence>
				{open && overlayStyle && (
					<motion.div
						className={css['overlay']}
						onClick={toggleSidebar}
						initial={{ opacity: 0 }}
						animate={{
							opacity: 1,
						}}
						exit={{
							opacity: 0,
						}}
						transition={{ duration: 0.2, type: 'tween' }}
					/>
				)}
			</AnimatePresence>
		</>
	)
}
